import { useRef } from "react";
import styled from "styled-components";
import { topicData, categoryData, statusData } from "../data";
import ArrayStore from "devextreme/data/array_store";
import ViewBox from "./ViewBox";

const InformationWrapper = styled.div`
  margin-top: 32px;
`;

const Information = (props) => {
  const { cat, catRef, id, isAuthor, mode, parts, setDetailsData, setPartsInfo, status, topic, topicRef } = props;
  const statusRef = useRef(null);

  return (
    <InformationWrapper>
      <ViewBox
        dataSource={
          new ArrayStore({
            key: "value",
            data: topicData,
          })
        }
        id={id}
        info={topic}
        infoRef={topicRef}
        isAuthor={isAuthor}
        mode={mode}
        status={status}
        type={"topic"}
      />
      <ViewBox
        dataSource={
          new ArrayStore({
            key: "value",
            data: categoryData,
          })
        }
        id={id}
        info={cat}
        infoRef={catRef}
        isAuthor={isAuthor}
        mode={mode}
        status={status}
        type={"cat"}
      />
      {mode !== "create" ? (
        <>
          <ViewBox
            dataSource={
              new ArrayStore({
                key: "value",
                data: statusData,
              })
            }
            id={id}
            info={status}
            infoRef={statusRef}
            mode={mode}
            setDetailsData={setDetailsData}
            setPartsInfo={setPartsInfo}
            status={status}
            type={"status"}
          />
          <ViewBox dataSource={parts} type={"parts"} />
        </>
      ) : (
        ""
      )}
    </InformationWrapper>
  );
};

export default Information;
